import { clsx } from 'clsx';

import type ITableCell from 'components/Table/interfaces/ITableCell';

import styles from './scss/SimpleTableCell.module.scss';

// Same behaviour as the shared TableCell, but with the launchpad's compact 5px padding.
function SimpleTableCell({
  children,
  className,
  head,
  colSpan,
  rowSpan,
}: ITableCell) {
  const classes = clsx(styles.root, className, {
    [styles.head]: head,
  });

  return (
    head ? (
      <th className={classes} colSpan={colSpan}>
        {children}
      </th>
    ) : (
      <td className={classes} colSpan={colSpan} rowSpan={rowSpan}>
        {children}
      </td>
    )
  );
}

export default SimpleTableCell;
